var provider = {
	phonetics: [
		'Alfa', 'Alfa-Echo', 'Bravo', 'Charlie', 'Charlie-Hotel', 'Delta', 'Echo',
		'Foxtrot', 'Golf', 'Hotel', 'India', 'Juliett', 'Kilo', 'Lima', 'Mike',
		'November', 'Oscar', 'Oscar-Echo', 'Papa', 'Quebec', 'Romeo', 'Sierra',
		'Sierra-Sierra', 'Tango', 'Uniform', 'Uniform-Echo', 'Victor', 'Whiskey',
		'X-ray', 'Yankee', 'Zulu'
	]
};

module.exports = provider;
